function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}
  
function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

class SiteHeader extends HTMLElement {
    constructor() {
      super();
  
      this.header = this.querySelector('header');
      this.headerHeight = this.header.offsetHeight; 
      this.headerGroupHeight = document.querySelector('.header-group').offsetHeight;
      this.overlay = document.querySelector(".site-overlay")

      this.megamenus = this.querySelectorAll(".has-megamenu")

      this.megamenus.forEach(m => {
        // m.addEventListener("mouseenter", () => {
        //   document.querySelector('body').classList.add('megamenu-open')
        //   m.classList.add('active')
        // })

        // m.addEventListener("mouseleave", () => {
        //   if(document.querySelector('body').classList.contains("megamenu-open")) {
        //     document.querySelector('body').classList.remove('megamenu-open')
        //   }
        // })

        m.addEventListener("click", () => {
          if(m.classList.contains('active')) {
            document.querySelector('body').classList.remove('megamenu-open')
          } else {
            document.querySelector('body').classList.add('megamenu-open')
            this.querySelectorAll(".has-megamenu.active").forEach(a => {
              a.classList.remove('active')
            })
          }

          m.classList.toggle('active')
        })
      })

      this.overlay.addEventListener("click", () => {
        document.querySelector('body').classList.remove('megamenu-open')
        this.querySelectorAll(".has-megamenu.active").forEach(a => {
          a.classList.remove('active')
        })
        window.PXUTheme.jsAjaxCart.hideDrawer();
      })
      

      document.querySelector("[data-open-cart]").addEventListener("click", () => {
        window.PXUTheme.jsAjaxCart.showDrawer();
      })
  
      // Check position on load
      this.onScroll();
      document.documentElement.style.setProperty('--header-height', (this.headerHeight + 1) + 'px');
      document.documentElement.style.setProperty('--header-group-height', (this.headerGroupHeight - 1) + 'px');
  
      // Watch for window changes
      window.addEventListener('scroll', this.onScroll.bind(this));
      window.addEventListener('resize', this.onWindowResize.bind(this));
    }

    handleMouseEnter() {

    }

    handleMouseLeave() {

    }
  
    onScroll(event) {
      if (window.scrollY > 5) {
        document.documentElement.classList.add('scrolled');
      } else {
        document.documentElement.classList.remove('scrolled');
      }
    }
  
    onWindowResize() {
      const resizeHeight = this.header.offsetHeight;
      const headerGroupHeight = document.querySelector('.header-group').offsetHeight;
  
      document.documentElement.style.setProperty('--header-height', (resizeHeight + 1) + 'px');
      document.documentElement.style.setProperty('--header-group-height', headerGroupHeight + 'px');
    }
  }
  
  window.customElements.define('site-header', SiteHeader);

class SearchDropdown extends HTMLElement {
    constructor() {
      super();
  
      this.isOpen = false;
      this.openButtons = document.querySelectorAll('[data-open-search]');
      this.closeButtons = document.querySelectorAll('[data-close-search]');
      this.overlay = document.querySelector('.page-overlay-under');
  
      this.openButtons.forEach(button => button.addEventListener('click', this.open.bind(this)));
      this.closeButtons.forEach(button => button.addEventListener('click', this.close.bind(this)));
    }
  
    open() {
      const search = this.querySelector('input[type="search"]');
  
      this.isOpen = true;
      this.classList.add('active');
      
      document.documentElement.classList.add('scrolled');
      this.overlay.classList.remove('invisible', 'opacity-0');
  
      // Focus on input
      setTimeout(() => {
        search.focus();
      }, 500);
  
      // Add listeners
      document.addEventListener('click', this.handleFocusOut.bind(this));
      this.addEventListener('keyup', this.handleKeyup.bind(this));
    }
  
    close() {
      this.isOpen = false;
      this.classList.remove('active');
  
      this.overlay.classList.add('invisible', 'opacity-0');
  
      if (window.scrollY < 5) {
        document.documentElement.classList.remove('scrolled');
      }
    }
  
    handleFocusOut(event) {
      const parent = event.target.closest('.header');
      if (parent == null && this.isOpen) this.close();
    }
  
    handleKeyup(event) {
      if (event.keyCode !== 27) return;
  
      this.close();
    }
  }
  
  window.customElements.define('search-dropdown', SearchDropdown);

class MobileMenu extends HTMLElement {
    constructor() {
      super();
  
      this.drawer = document.getElementById('mobile-menu');
      this.header = document.getElementById('.header');
  
      this.trigger = document.querySelector('.mobile-menu-trigger');
      this.menuClose = document.querySelector('[data-close-menu]');
  
      this.dropdownButtons = this.querySelectorAll('.dropdown-button');

      this.back = this.querySelector("[data-dropdown-back]")
      
      this.drawer.addEventListener('keydown', (evt) => evt.code === 'Escape' && this.close());
      this.bindEvents();
    }
  
    bindEvents() {
      this.trigger.addEventListener('click', event => {
        this.trigger.classList.contains('open') ? this.close() : this.open();
      });

      this.menuClose.addEventListener('click', event => this.close() )
  
      this.dropdownButtons.forEach(dropdownBtn => dropdownBtn.addEventListener('click', this.handleButtonClick.bind(this)));
      this.back.addEventListener("click", this.handleBack.bind(this))
    }
  
    open() {
      this.drawer.setAttribute('aria-hidden', 'false');
      this.drawer.setAttribute('aria-expanded', 'true');
  
      this.trigger.classList.add('open');
      document.documentElement.classList.add('scrolled');
  
      document.body.classList.add('overflow-hidden');
    }
  
    close() {
      this.drawer.setAttribute('aria-hidden', true);
      this.drawer.removeAttribute('aria-expanded', true);
  
      this.trigger.classList.remove('open');
      if (window.scrollY < 6) document.documentElement.classList.remove('scrolled');
  
      document.body.classList.remove('overflow-hidden');
    }
  
    handleButtonClick(event) {
      event.preventDefault();
      const button = event.currentTarget.tagName == "BUTTON" ? event.currentTarget : event.currentTarget.closest("button");
      const dropdown = button.nextElementSibling;
  
      if (dropdown.classList.contains('active')) {
        dropdown.classList.remove('active');
        this.querySelector("mobile-menu__nav").setAttribute("data-submenu-open", false)
      } else {
        dropdown.classList.add('active');
        this.querySelector(".mobile-menu__nav").setAttribute("data-submenu-open", true)
      }
    }

    handleBack(event) {
        event.preventDefault()
        const activeDropdown = this.querySelector(".dropdown.active")

        if(activeDropdown) {
            activeDropdown.classList.remove('active');
            this.querySelector(".mobile-menu__nav").setAttribute("data-submenu-open", false)
        }
    }
  }
  
  customElements.define('mobile-menu', MobileMenu);

 class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
  
      this.input = this.querySelector('input[type="search"]');
      this.predictiveSearchResults = this.querySelector('.predictive-search');
  
      this.input ? this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)) : ''
    }
  
    onChange() {
      const searchTerm = this.input.value.trim();
  
      if (!searchTerm.length) {
        this.close();
        return;
      }
  
      this.getSearchResults(searchTerm);
    }
  
    getSearchResults(searchTerm) {
      fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }
  
          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }
  
    open() {
      this.predictiveSearchResults.style.display = 'block';
  
      // Show all results
      this.querySelector('[data-submit]').addEventListener('click', this.onSubmit.bind(this));
    }
  
    close() {
      this.predictiveSearchResults.style.display = 'none';
    }
  
    onSubmit(event) {
      event.preventDefault();
  
      this.querySelector('form').submit();
    }
  }
  
  window.customElements.define('predictive-search', PredictiveSearch);